<template>
    <div>
        <header>
            <section>
                <div class="nav">
                    <div class="brand">
                        <router-link v-bind:to="{ name: 'Dashboard' }"><h1>Elisabot</h1></router-link>
                        <h4 class="profile">Willkommen {{ userProfile.name }}</h4>
                    </div>
                    <div>
                        <ul class="links">
                            <li class="nav-item"><router-link v-bind:to="{ name: 'Dashboard' }">Dashboard</router-link></li>
                            <li class="nav-item"><router-link v-bind:to="{ name: 'Baustellen' }">Baustellen</router-link></li>
                            <li class="nav-item"><router-link v-bind:to="{ name: 'Create' }">Baustelle anlegen</router-link></li>
                            <li class="nav-item"><router-link v-bind:to="{ name: 'Angebote' }">Angebote</router-link></li>
                            <li class="nav-item"><router-link v-bind:to="{ name: 'CreateAngebot' }">Angebot anlegen</router-link></li>
                            <li class="nav-item"><router-link v-bind:to="{ name: 'Archiv' }">Archiv</router-link></li>
                            <li class="nav-item"><a @click="logout">Logout</a></li>
                        </ul>
                    </div>
                </div>
            </section>
        </header>
    </div>
</template>

<script>
const fb = require("../fbConfig.js");
import { mapState } from "vuex";
import { currentUser } from "../fbConfig";

export default {
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  methods: {
    logout() {
      fb.auth
        .signOut()
        .then(() => {
          this.$store.dispatch("clearData");
          this.$router.push("/login");
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.nav {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.links {
  display: flex;
  padding: 5px;
}

.nav-item a {
  padding: 0 10px;
  cursor: pointer;
  font-size: 14px;
}

.nav ul {
  margin: 0;
}

.links .router-link-active {
  font-family: "Avenir Heavy", Helvetica, Arial, sans-serif;
}

.profile {
  margin: 0 0 0 15px;
  font-weight: 500;
  font-size: 18px;
}

.brand {
  display: flex;
  align-items: baseline;
}

.brand h1 {
  margin: 0;
}

</style>